import { render } from "./FooterBar.vue?vue&type=template&id=0a7e72a2&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=0a7e72a2&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/muziekdichtbij/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7e72a2"]])

export default __exports__